module.exports = __webpack_public_path__ + "static/media/warn.baf28a77.svg";